import { createContext, useContext, useState } from "react";
import { DefaultShowObjectDetection } from "lib/consts/inspections/objectDetection";

export const ObjectDetectionContext = createContext();
ObjectDetectionContext.displayName = "InspectionObjectDetection";
export const useObjectDetection = () => useContext(ObjectDetectionContext);

const ObjectDetectionProvider = ({ children }) => {
    const [showObjectDetection, setShowObjectDetection] = useState(DefaultShowObjectDetection);

    return (
        <ObjectDetectionContext.Provider
            value={{
                showObjectDetection,
                setShowObjectDetection,
            }}
        >
            {children}
        </ObjectDetectionContext.Provider>
    );
};

export default ObjectDetectionProvider;
